// extracted by mini-css-extract-plugin
module.exports = {"title":"ZlHoY","img":"_1qNtk","buttonLine":"_3rk0Z"};